import React, { Component } from "react";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStroopwafel } from "@fortawesome/free-solid-svg-icons";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import {
  faAngleDown,
  faStopCircle,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
// import { SegmentedControl } from 'segmented-control'
import { Menu } from "semantic-ui-react";
import colors from "../../colors";
// import {Link} from "react-router-dom";

library.add(faStroopwafel);
library.add(faAngleRight);
library.add(faAngleDown);
library.add(faStopCircle);
library.add(faCircle);

export default class TreeNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: false,
      margin: props.margin,
      selected: false,
      color: props.color,
      prevColor: props.color,
    };
  }

  //new irrigation

  doCommandAreaChange = (e) => {
    let s = e.target.value;
    this.props.doCommandAreaChange(s);
  };

  onClick = () => {
    this.setState({
      collapsed: !this.state.collapsed,
      color: !this.state.collapsed
        ? colors["sidebar-sub-menu"]
        : this.state.prevColor,
    });
  };

  onClickChild = () => {
    // this.setState({selected:!this.state.selected})
    let menu = this.props.parent
      ? this.props.parent + "-" + this.props.data.name
      : this.props.data.name;
    console.log(menu);
    if (this.props.data.ismap && this.props.selectedMenu !== menu) {
      this.props.toggleSelectedNodeStatus(menu);
      this.props.setSelectedMenu(menu);
      this.props.setSelectedLayer(menu);
      this.props.enableDatePicker(this.props.data.dateReq);
      this.props.enableYearSeason(this.props.data.yearseason);
    }

    // this.props.data.ismap?this.props.setSelectedLayer(this.props.data.name,this.props.data.defaultLayer):null
  };

  componentDidMount() {
    if (this.props.data.hasdefault) {
      this.onClick();
    }
    if (
      this.props.selectedLayerLink === this.props.data.name ||
      this.props.data.default
    ) {
      this.onClickChild();
    }
  }
  doSateliteChange = (e) => {
    let s = e.target.value;
    
    console.log('test123', this.props.selectedMenu);

    this.props.doSateliteChange(s, this.props.selectedMenu);
  };

  
  
  cropseasonChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.cropseasonChange(s);
    }
  };

  histcropseasonChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.histcropseasonChange(s);
    }
  };

  histyearChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.histyearChange(s, this.props.data.name);
    }
  };

  cropyearChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.cropyearChange(s);
      
    }
  };

  seasonChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.seasonChange(s, this.props.selectedMenu);
    }
  };


  dateLayerChange = (e) => {
    // console.log('dateChange123', e);
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.dateChange(s, this.props.selectedMenu);
    }
  };

  yearChange = (e) => {
    if (e.target.value !== "#") {
      let s = e.target.value;
      this.props.yearChange(s, this.props.selectedMenu);
    }
  };

  render() {
    // console.log(this.props.selectedLayerLink===this.props.data.name)
    // console.log(this.state)
    console.log(this.props.cropmapseasons)
    console.log("irrii collapse",this.state.collapsed)
    let cropyears, hist_cayears, hist_giryears, hist_cwsimyears;
    
    let cropseasons, hist_cropseasons;
    let commandareas;
    let subtree = null;

    // console.log('CA 1', this.props.ca_areas);

    if(this.props.ca_areas) {
      console.log('CA 1', this.props.ca_areas);
      commandareas = this.props.ca_areas.map((result)=>{
        console.log('CA 3', result);
        return(<option value={result.admin_name}>{result.full_name}</option>)
      });

      console.log('CA 2', commandareas);
    }

    if(this.props.cropmapyears)
    {
      console.log('Test 1', this.props.cropmapyears)
     cropyears= this.props.cropmapyears.map((result)=>{
      console.log('CMY 3', result);
        return(<option value={result.year}>{result.year}</option>)
      })
    }
    if(this.props.cropmapseasons)
    {
      cropseasons= this.props.cropmapseasons.map((result)=>{
        return(<option value={result.season.toLowerCase()}>{result.season}</option>)
      })
    }

    if(this.props.hist_cropmapseasons)
    {
      hist_cropseasons= this.props.hist_cropmapseasons.map((result)=>{
        // console.log('Test 123 se', result);
        return(<option value={result.layername + '###' + result.season.toLowerCase()}>{result.season}</option>)
      })
    }

    if(this.props.caHistYears)
    {
      hist_cayears= this.props.caHistYears.map((result)=>{
        return(<option value={result}>{result}</option>)
      })
    }

    if(this.props.girHistYears)
    {
      hist_giryears= this.props.girHistYears.map((result)=>{
        return(<option value={result}>{result}</option>)
      })
    }

    if(this.props.cwsimHistYears)
    {
      hist_cwsimyears= this.props.cwsimHistYears.map((result)=>{
        return(<option value={result}>{result}</option>)
      })
    }

    if (this.props.data.children) {
      subtree = this.props.data.children.map((child, key) => {
        return (
          <TreeNode
            key={key}
            data={child}
            cropyear={this.props.cropyear}
            cropseason={this.props.cropseason}
            cropseasonChange={this.props.cropseasonChange}
            cropyearChange={this.props.cropyearChange}
            cropmapyears={this.props.cropmapyears}
            cropmapseasons={this.props.cropmapseasons}
            doSateliteChange={this.props.doSateliteChange}
            seasonChange={this.props.seasonChange}
            dateChange={this.props.dateChange}
            yearChange={this.props.yearChange}
            increment={this.props.increment}
            decrement={this.props.decrement}
            setSelectedLayer={this.props.setSelectedLayer}
            setSelectedMenu={this.props.setSelectedMenu}
            margin={this.state.margin + 5}
            season={this.props.season}
            year={this.props.year}
            color={this.state.color}
            selectedLayerLink={this.props.selectedLayerLink}
            toggleSelectedNodeStatus={this.props.toggleSelectedNodeStatus}
            selectedNodeStaus={this.props.selectedNodeStaus}
            selectedMenu={this.props.selectedMenu}
            enableDatePicker={this.props.enableDatePicker}
            parent={this.props.data.name}
            enableYearSeason={this.props.enableYearSeason}

            ca_areas = {this.props.ca_areas}
            doCommandAreaChange = {this.props.doCommandAreaChange}
            selectedCommandArea = {this.props.selectedCommandArea}

            histcropseasonChange={this.props.histcropseasonChange}
            histyearChange={this.props.histyearChange}
            hist_cropmapseasons={this.props.hist_cropmapseasons}
            hist_cropseason={this.props.hist_cropseason}

            caHistYears = {this.props.caHistYears}
            girHistYears = {this.props.girHistYears}
            cwsimHistYears = {this.props.cwsimHistYears}

            opticalSensors ={this.props.opticalSensors}
            opticalYears ={this.props.opticalYears}
            opticalSeasons ={this.props.opticalSeasons}
            opticalDates ={this.props.opticalDates}
            selectedOpticalSensor ={this.props.selectedOpticalSensor}
            selectedOpticalYear ={this.props.selectedOpticalYear}
            selectedOpticalSeason ={this.props.selectedOpticalSeason}
            selectedOpticalDate ={this.props.selectedOpticalDate}

            mwSensors ={this.props.mwSensors}
            mwYears ={this.props.mwYears}
            mwSeasons ={this.props.mwSeasons}
            mwDates ={this.props.mwDates}
            selectedMWSensor ={this.props.selectedMWSensor}
            selectedMWYear ={this.props.selectedMWYear}
            selectedMWSeason ={this.props.selectedMWSeason}
            selectedMWDate ={this.props.selectedMWDate}


          />
        );
      });
    }

    if (subtree) {
      return (
        <div style={{ background: colors.final_side }}>
          <Menu.Item
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClick}
            style={{ textAlign: "left", marginLeft: `${this.state.margin}px` }}
            disabled={this.props.data.disabled}
          >
            {/* <div style={{marginLeft:`${this.state.margin}px`}}/> */}

            <div style={{ display: "flex" }}>
              <div
                style={{
                  width: "80%",
                  fontSize: !this.props.data.disabled ? "13px" : "unset",
                  color: !this.props.data.disabled ? colors.textcolor : "unset",
                  fontWeight: !this.props.data.disabled ? "bold" : "unset",
                }}
              >
                {this.props.data.displayname}
              </div>
              <div style={{ textAlign: "right", width: "20%" }}>
                {this.state.collapsed ? (
                  <FontAwesomeIcon icon="angle-down" />
                ) : (
                  <FontAwesomeIcon icon="angle-right" />
                )}
              </div>
            </div>
          </Menu.Item>

          {this.state.collapsed ? (
            <div style={{ background: colors.final_side_sub }}>{subtree}</div>
          ) : null}
        </div>
      );
    } else {
      return (
        <div
          style={{
            background: !this.props.data.disabled ? colors.final_side_sub : "",
            padding: "0px",
          }}
        >
          <Menu.Item
            as="div"
            data-id={this.props.data.id}
            onClick={this.onClickChild}
            style={{ textAlign: "left" }}
            disabled={this.props.data.disabled}
          >
            {/* <span style={{marginLeft:`${this.state.margin+5}px`}}/> */}
            <div
              style={{
                display: "flex",
                padding: "0px",
                fontSize: !this.props.data.disabled ? "13px" : "unset",
                color: !this.props.data.disabled ? colors.text_sub_color : "unset",
                fontWeight: !this.props.data.disabled ? "bold" : "unset",
              }}
            >
              {/* {this.state.collapsed?<div style={{ width:"10%"}}/>:null} */}
              {this.props.data.ismap ? (
                <div style={{ width: "10%" }}>
                  {this.props.selectedNodeStaus[
                    this.props.parent
                      ? this.props.parent + "-" + this.props.data.name
                      : this.props.data.name
                  ] ? (
                    <FontAwesomeIcon icon="stop-circle" />
                  ) : (
                    <FontAwesomeIcon icon="circle" />
                  )}
                </div>
              ) : null}

              <div style={{ width: "90%" }}>{this.props.data.displayname}</div>
            </div>
          </Menu.Item>
          
          {this.props.data.name === "Optical" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (


            <div style={{ textAlign: "center" }}>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.doSateliteChange}
                  value={this.props.selectedOpticalSensor}
                  selected={this.props.selectedOpticalSensor}
                >
                  <option value="#">Select Satellite</option>
                  {this.props.opticalSensors.map((option) => (
                    <option key={option.sensor} value={option.sat}>
                      {option.satellite}
                    </option>
                  ))}
                  
                  
                  {/* <option value="landsat8" disabled>Landsat8</option> */}
                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.yearChange}
                  value={this.props.selectedOpticalYear}
                  selected={this.props.selectedOpticalYear}
                >
                  <option value="#">Select Year</option>
                  {/* <option value="2018">2018</option> */}
                  
                  {this.props.opticalYears.map((option) => (
                    <option key={option.year} value={option.year}>
                      {option.year}
                    </option>
                  ))}

                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.seasonChange}
                  value={this.props.selectedOpticalSeason}
                  selected={this.props.selectedOpticalSeason}
                >
                  <option value="#">Select Season</option>
                  
                  {this.props.opticalSeasons.map((option) => (
                    <option key={option.season} value={option.season}>
                      {option.season}
                    </option>
                  ))}


                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.dateLayerChange}
                  value={this.props.selectedOpticalDate}
                  selected={this.props.selectedOpticalDate}
                >
                  <option value="#">Select Date</option>
                  
                  {this.props.opticalDates.map((option) => (
                    <option key={option.date} value={option.date}>
                      {option.date}
                    </option>
                  ))}


                </select>
              </div>



            </div>


          ) : null}

          {this.props.data.name === "Microwave" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            
            <div style={{ textAlign: "center" }}>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.doSateliteChange}
                  value={this.props.selectedMWSensor}
                  selected={this.props.selectedMWSensor}
                >
                  <option value="#">Select Satellite</option>
                  {this.props.mwSensors.map((option) => (
                    <option key={option.sensor} value={option.sat}>
                      {option.satellite}
                    </option>
                  ))}
                  
                  
                  {/* <option value="landsat8" disabled>Landsat8</option> */}
                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.yearChange}
                  value={this.props.selectedMWYear}
                  selected={this.props.selectedMWYear}
                >
                  <option value="#">Select Year</option>
                  {/* <option value="2018">2018</option> */}
                  
                  {this.props.mwYears.map((option) => (
                    <option key={option.year} value={option.year}>
                      {option.year}
                    </option>
                  ))}

                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.seasonChange}
                  value={this.props.selectedMWSeason}
                  selected={this.props.selectedMWSeason}
                >
                  <option value="#">Select Season</option>
                  
                  {this.props.mwSeasons.map((option) => (
                    <option key={option.season} value={option.season}>
                      {option.season}
                    </option>
                  ))}


                </select>
              </div>

              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.dateLayerChange}
                  value={this.props.selectedMWDate}
                  selected={this.props.selectedMWDate}
                >
                  <option value="#">Select Date</option>
                  
                  {this.props.mwDates.map((option) => (
                    <option key={option.date} value={option.date}>
                      {option.date}
                    </option>
                  ))}


                </select>
              </div>

            </div>


          ) : null}

          {this.props.data.name === "Crop Map" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.cropyearChange}
                  value={this.props.cropyear}
                  selected={this.props.cropyear}
                >
                  <option value="#">Select Year</option>
                  {/* <option value="2020" selected>
                    2020
                  </option>
                  <option value="2019">2019</option>
                  <option value="2018">2018</option>
                  <option value="2017">2017</option>
                  <option value="2016">2016</option>
                  <option value="2015">2015</option>
                  <option value="2014">2014</option>
                  <option value="2013">2013</option> */}
                  {cropyears}
                </select>
              </div>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.cropseasonChange}
                  value={this.props.cropseason}
                  selected={this.props.cropseason}
                >
                  <option value="#">Select Season</option>
                  {/* <option value="kharif" selected>
                    Kharif
                  </option>
                  {this.props.year !== "2020" ? (
                    <option value="rabi">Rabi</option>
                  ) : null} */}
                  {cropseasons}
                </select>
              </div>
            </div>
          ) : null}
          
          {(this.props.data.name === "Crop Map Historic" || this.props.data.name === "Irrigation Requirement" || this.props.data.name === "Irrigation System Performance") &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ textAlign: "-webkit-center" }}>
                {/* <select
                  // onChange={this.cropyearChange}
                  // value={this.props.cropyear}
                  // selected={this.props.cropyear}
                >
                  <option value="#">Select Command Area</option>
                  {/* {cropyears} 
                </select> */}
                <select
                  onChange={this.doCommandAreaChange}
                  value={this.props.selectedCommandArea}
                  selected={this.props.selectedCommandArea}
                >
                  {commandareas}
                </select>
              </div>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.histyearChange}
                  value={this.props.hist_selectedyear}
                  selected={this.props.hist_selectedyear}
                >
                  <option value="#">Select Year</option>
                  {/* <option value="2021">2021</option> */}
                  { (this.props.data.name === "Crop Map Historic") ? hist_cayears : (this.props.data.name === "Irrigation Requirement") ? hist_giryears : (this.props.data.name === "Irrigation System Performance") ? hist_cwsimyears : null }
                </select>
              </div>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.histcropseasonChange}
                  value={this.props.hist_cropseason}
                  selected={this.props.hist_cropseason}
                >
                  <option value="#">Select Season</option>
                  {/* <option value="kharif" selected>
                    Kharif
                  </option>
                  {this.props.year !== "2020" ? (
                    <option value="rabi">Rabi</option>
                  ) : null} */}
                  {hist_cropseasons}
                </select>
              </div>
            </div>
          ) : null}
          
          {this.props.data.name === "Command Area" &&
          this.props.selectedNodeStaus[
            this.props.parent
              ? this.props.parent + "-" + this.props.data.name
              : this.props.data.name
          ] ? (
            <div style={{ textAlign: "center" }}>
              <div style={{ textAlign: "-webkit-center" }}>
                <select
                  onChange={this.doCommandAreaChange}
                  value={this.props.selectedCommandArea}
                  selected={this.props.selectedCommandArea}
                >
                  {commandareas}
                </select>
              </div>
              <br/>

            </div>
          ) : null}

        </div>
      );
    }
  }
}
